import React from "react";

const BlogSection = () => {
  return (
    <div>
      {/* blog section */}
      <section className="blog-section v1 layout-radius">
        <div className="boxcar-container">
          <div className="boxcar- wow fadeInUp">
            <ul className="breadcrumb">
              <li>
                <a href="#">Home</a>
              </li>
              <li>
                <span>Cars for Sale</span>
              </li>
            </ul>
            <h2>Blog List</h2>
          </div>
          <nav className="wow fadeInUp" data-wow-delay="100ms">
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className="nav-link active"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
              >
                Auto Detailing
              </button>
              <button
                className="nav-link"
                id="nav-profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-profile"
                type="button"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
              >
                Car News
              </button>
              <button
                className="nav-link"
                id="nav-contact-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-contact"
                type="button"
                role="tab"
                aria-controls="nav-contact"
                aria-selected="false"
              >
                Buying Guides
              </button>
            </div>
          </nav>
          <div
            className="tab-content wow fadeInUp"
            data-wow-delay="200ms"
            id="nav-tabContent"
          >
            <div
              className="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div className="row">
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div className="inner-box wow fadeInUp">
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog-1.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="blog-single.html" >
                          This Long-Awaited Technology May Finally Change the
                          World
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog-2.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="blog-single.html" >
                          This Long-Awaited Technology May Finally Change the
                          World
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog-3.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="blog-single.html" >
                          This Long-Awaited Technology May Finally Change the
                          World
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-1.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          How To Save On Car Fuel Costs - The Ultimate Guide
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-2.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Selling a Modified Car: How to Secure the Best Price
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-3.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Searches For Used EVs in London Are Rising
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-4.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">Best Used Electric Cars for Under £30K</a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-5.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Top 10 Car Shows and Events in &amp; around London
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-6.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Golf vs Polo: A Comparison of Two Volkswagen Classics
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-profile-tab"
            >
              <div className="row">
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div className="inner-box wow fadeInUp">
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog-1.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="blog-single.html" >
                          This Long-Awaited Technology May Finally Change the
                          World
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog-2.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="blog-single.html" >
                          This Long-Awaited Technology May Finally Change the
                          World
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog-3.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="blog-single.html" >
                          This Long-Awaited Technology May Finally Change the
                          World
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-1.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          How To Save On Car Fuel Costs - The Ultimate Guide
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-2.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Selling a Modified Car: How to Secure the Best Price
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-3.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Searches For Used EVs in London Are Rising
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-4.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">Best Used Electric Cars for Under £30K</a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-5.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Top 10 Car Shows and Events in &amp; around London
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-6.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Golf vs Polo: A Comparison of Two Volkswagen Classics
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-contact"
              role="tabpanel"
              aria-labelledby="nav-contact-tab"
            >
              <div className="row">
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div className="inner-box wow fadeInUp">
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog-1.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="blog-single.html" >
                          This Long-Awaited Technology May Finally Change the
                          World
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog-2.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="blog-single.html" >
                          This Long-Awaited Technology May Finally Change the
                          World
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog-3.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="blog-single.html" >
                          This Long-Awaited Technology May Finally Change the
                          World
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-1.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          How To Save On Car Fuel Costs - The Ultimate Guide
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-2.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Selling a Modified Car: How to Secure the Best Price
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-3.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Searches For Used EVs in London Are Rising
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-4.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">Best Used Electric Cars for Under £30K</a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-5.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Top 10 Car Shows and Events in &amp; around London
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* blog-block */}
                <div className="blog-block col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="inner-box wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="image-box">
                      <figure className="image">
                        <a href="#">
                          <img src="images/resource/blog4-6.jpg"   />
                        </a>
                      </figure>
                      <span className="date">news</span>
                    </div>
                    <div className="content-box">
                      <ul className="post-info">
                        <li>Ali Tufan</li>
                        <li>April 20, 2023</li>
                      </ul>
                      <h6 className="title">
                        <a href="#">
                          Golf vs Polo: A Comparison of Two Volkswagen Classics
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="pagination-sec">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <a className="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">
                      <svg
                        width={12}
                        height={12}
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.57983 5.99989C2.57983 5.7849 2.66192 5.56987 2.82573 5.4059L7.98559 0.24617C8.31382 -0.0820565 8.84598 -0.0820565 9.17408 0.24617C9.50217 0.574263 9.50217 1.10632 9.17408 1.43457L4.60841 5.99989L9.17376 10.5654C9.50185 10.8935 9.50185 11.4256 9.17376 11.7537C8.84566 12.0821 8.31366 12.0821 7.98544 11.7537L2.82555 6.59404C2.66176 6.42999 2.57983 6.21495 2.57983 5.99989Z"
                          fill="#050B20"
                        />
                      </svg>{" "}
                    </span>
                    <span className="sr-only">Previous</span>
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    1
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    2
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    3
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    4
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    5
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    ...
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    20
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">
                      <svg
                        width={12}
                        height={12}
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_2880_6407)">
                          <path
                            d="M9.42017 6.00011C9.42017 6.2151 9.33808 6.43013 9.17427 6.5941L4.01441 11.7538C3.68618 12.0821 3.15402 12.0821 2.82592 11.7538C2.49783 11.4257 2.49783 10.8937 2.82592 10.5654L7.39159 6.00011L2.82624 1.43461C2.49815 1.10652 2.49815 0.574382 2.82624 0.246315C3.15434 -0.0820709 3.68634 -0.0820709 4.01457 0.246315L9.17446 5.40596C9.33824 5.57001 9.42017 5.78505 9.42017 6.00011Z"
                            fill="#050B20"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2880_6407">
                            <rect
                              width={12}
                              height={12}
                              fill="white"
                              transform="translate(12 12) rotate(-180)"
                            />
                          </clipPath>
                        </defs>
                      </svg>{" "}
                    </span>
                    <span className="sr-only">Next</span>
                  </a>
                </li>
              </ul>
              <div className="text">Showing results 1-30 of 1,415</div>
            </nav>
          </div> */}
        </div>
      </section>
      {/* End blog-section */}
    </div>
  );
};

export default BlogSection;
